import { ActionProps } from "digimaker-ui/ActionsRender";
import {
  Delete,
  Move,
  MultiUpload,
  SetPriority,
  SetToTop,
  CopyFilepath,
} from "digimaker-ui/actions";
import { ViewSettingsType } from "digimaker-ui";
import { UserRoles } from "digimaker-ui/view";
import React from "react";

export const leftConfig = [
  {
    name: "Sites",
    icon: "fa-desktop",
    path: "/main/3",
    menu: [
      {
        name: "Sites",
        type: "treemenu",
        contenttype: ["folder", "page"],
        icon: "fas fa-home",
        is_site: true,
        open: true,
        root: 3,
      },
      // {
      //   name: "Shared",
      //   type: "treemenu",
      //   contenttype: ["folder"],
      //   icon: "fas fa-share-alt",
      //   open: false,
      //   root: 460,
      // },
      {
        name: "Resources",
        type: "treemenu",
        contenttype: ["folder"],
        icon: "far fa-images",
        open: false,
        root: 9,
      },
      {
        name: "Matchfit lists",
        icon: "fas fa-list",
        path: "/matchfit/list-config",
      },
    ],
  },
  {
    name: "Users",
    icon: "fa-users",
    path: "/main/4",
    menu: [
      {
        name: "Organizations",
        type: "treemenu",
        contenttype: ["usergroup"],
        icon: "fas fa-sitemap",
        root: 4,
      },
      {
        name: "Roles",
        icon: "fas fa-user-tag",
        path: "/main/7",
      },
    ],
  },
];

/* get list config based on parent and content type */
export const getListConfig = (_parent: any, contenttype: string) => {
  const commonSettings = {
    show_header: true,
    show_table_header: true,
    pagination: 5,
    sort: [],
    row_actions: [
      {
        link: "/edit/{_location_id}?from=/main/{_from_id}",
        name: "Edit",
        icon: "icon-edit",
      },
      Delete,
    ],
  };

  const listConfg = {
    folder: {
      ...commonSettings,
      sort_default: [["published", "desc"]],
      columns: [
        { header: "Name", field: "name" },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
    },
    course: {
      sort_default: [["c.name", "asc"]],
      sort: ["name"],
      columns: [
        { header: "ID", render: (content) => content.id },
        { header: "Name", render: (content) => content.name },
        {
          header: "Is Bachelor",
          render: (content) => (content.is_bachelor ? "Yes" : ""),
        },
      ],
      show_header: false,
      show_table_header: true,
      can_select: false,
      actions: [],
      row_actions: [
        {
          link: "/edit/course/{id}?from=/main/468",
          icon: "fas fa-edit",
          name: "Edit",
        },
        {
          com: "action:delete",
          icon: "fas fa-trash",
          name: "delete",
        },
      ],
      pagination: 10,
      row_more: [],
    },
    agency: {
      sort_default: [["c.name", "asc"]],
      sort: ["name"],
      columns: [
        { header: "ID", render: (content) => content.id },
        { header: "Name", render: (content) => content.name },
      ],
      show_header: false,
      show_table_header: true,
      can_select: false,
      actions: [],
      row_actions: [
        {
          link: "/edit/agency/{id}?from=/main/480",
          icon: "fas fa-edit",
          name: "Edit",
        },
        {
          com: "action:delete",
          icon: "fas fa-trash",
          name: "delete",
        },
      ],
      pagination: 10,
      row_more: [],
    },
    subject: {
      sort_default: [["c.name", "asc"]],
      sort: { "c.name": "asc", course: "asc", stage_year: "asc" },
      // columns: ["name", "code", "course", "stage_year", "credit"],
      columns: [
        { header: "ID", render: (content) => content.id },
        { header: "Name", render: (content) => content.name },
        { header: "Code", render: (content) => content.code },
        { header: "Course", render: (content) => content.course },
        { header: "Stage Year", render: (content) => content.stage_year },
        { header: "Credit", render: (content) => content.credit },
      ],
      show_header: false,
      show_table_header: true,
      can_select: false,
      actions: [{ com: "filter:name" }],
      row_actions: [
        {
          link: "/subject/view/{id}",
          icon: "fas fa-angle-right",
          name: "View",
        },
        {
          link: "/edit/subject/{id}?from=/main/469",
          icon: "fas fa-edit",
          name: "Edit",
        },
        {
          com: "action:delete",
          icon: "fas fa-trash",
          name: "delete",
        },
      ],
      pagination: 15,
      row_more: [],
    },
    image: {
      sort_default: [["id", "desc"]],
      sort: [],
      columns: ["name", "image", "author", "published", "modified"],
      block_fields: ["image", "name", "modified"],
      show_header: true,
      show_table_header: true,
      actions: [],
      viewmode: "block",
      row_actions: [
        {
          link: "/edit/{_contenttype_id}?from=/main/{_from_id}",
          name: "Edit",
          icon: "icon-edit",
        },
        Delete,
      ],
      pagination: 25,
      row_more: ["export"],
      blockview_columns: ["image", "name", "modified"],
    },
    file: {
      sort_default: [["published", "desc"]],
      sort: [],
      columns: [
        { header: "ID", field: "id" },
        {
          header: "Title",
          render: (content) => (
            <a href={"/var/" + content.path} target="_blank">
              {content.title}
            </a>
          ),
        },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
      show_header: true,
      show_table_header: true,
      actions: [],
      row_actions: [
        CopyFilepath,
        {
          link: "/edit/{_contenttype_id}?from=/main/{_from_id}",
          name: "Edit",
          icon: "icon-edit",
        },
        Delete,
      ],
      pagination: 10,
      row_more: [],
    },
    usergroup: {
      ...commonSettings,
      sort_default: [["published", "desc"]],
      sort: [],
      columns: [
        { header: "Title", field: "title" },
        { header: "Author", render: (content) => content.metadata.author_name },
        { header: "Published", field: "published" },
        { header: "Modified", field: "modified" },
      ],
    },
    user: {
      ...commonSettings,
      sort_default: [["name", "asc"]],
      sort: { name: "asc", modified: "desc" },
      columns: [
        {
          header: "Name",
          render: (content) => content.firstname + " " + content.lastname,
        },
        { header: "Modified", field: "modified" },
      ],
      pagination: 25,
    },
    role: {
      ...commonSettings,
      sort_default: [["name", "asc"]],
      columns: [{ header: "Name", render: (content) => content.title }],
      row_actions: [
        { link: "/main/role/{cid}", name: "Detail", icon: "fa-arrow-right" },
        {
          link: "/edit/role/{cid}?from=/main/7",
          icon: "fas fa-edit",
          name: "Edit",
        },
      ],
      pagination: 10,
    },
  };

  return listConfg[contenttype] ? listConfg[contenttype] : commonSettings;
};

/** get main config based on content */
export const getMainConfig = (content: any) => {
  const locationId = content.location.id;
  switch (locationId) {
    case 467:
      return {
        list: ["student"],
        new: ["student"],
        actions: [],
      };
    case 468:
      return {
        list: ["course"],
        new: ["course"],
        actions: [],
      };
    case 469:
      return {
        list: ["subject"],
        new: ["subject"],
        actions: [],
      };
    case 480:
      return {
        list: ["agency"],
        new: ["agency"],
        actions: [],
      };
    case 4:
    case 477:
      return {
        list: ["user"],
        new: ["user"],
        actions: [],
      };
    case 7:
      return {
        list: ["role"],
        new: ["role"],
        actions: [],
      };
    default:
      return {
        list: [],
        new: [],
        actions: [],
      };
  }

  const mainConfig = {
    folder: {
      actions: [(actionProps: ActionProps) => <SetPriority {...actionProps} />],
    },
    frontpage: {
      list: ["frontpage_block"],
    },
    page: {
      list: ["page", "folder"],
      new: ["page", "folder"],
      actions: [
        {
          link: "/fulledit/{_location_id}",
          name: "Full edit",
          icon: "icon-edit",
          title: "Edit the content",
        },
      ],
    },
    role: {
      view: true,
    },
    article: {
      view: true,
      metainfo: true,
      actions: [(actionProps: ActionProps) => <Move {...actionProps} />],
    },
    user: {
      view: true,
      viewComponent: UserRoles,
    },
  };

  let commonActions = [
    {
      link: "/edit/{_location_id}",
      name: "Edit",
      icon: "icon-edit",
      title: "Edit the content",
    },
    Delete,
  ];

  const commonMain = { list: [], new: [] };
  let result = { ...commonMain, ...mainConfig[content.metadata.contenttype] };
  if (result["actions"]) {
    result["actions"] = [...commonActions, ...result["actions"]];
  }

  let list = [] as string[];
  if (content.metadata.contenttype === "folder") {
    if (content.location.id == 3) {
      list = ["block", "page"];
    } else {
      if (content.children_type) {
        const childrenType = content.children_type.value;
        list.push(childrenType);
      }
      let ids = content.location.hierarchy.split("/");
      if (ids.includes("10") || ids.includes("461")) {
        list = [...list, "image"];
        result["actions"] = [
          ...result["actions"],
          {
            link: "/image/multiupload/{_location_id}",
            name: "Multi upload",
            icon: "fas fa-image",
            title: "Multi upload",
          },
        ];
      }

      if (ids.includes("4")) {
        list = [...list, "user"];
      }

      if (ids.includes("7")) {
        list = [...list, "role"];
      }
    }

    result["list"] = list;
    result["new"] = ["folder", ...list];
  }
  return result;
};

export const getBrowseConfig = () => {
  return {
    filter: {
      "*": { contenttype: ["folder"] },
      usergroup: { contenttype: ["usergroup"] },
      user: { contenttype: ["folder"] },
      sv_product: { contenttype: ["sv_product_package"] },
    },
    list: {
      "*": {
        level: 1,
        can_select: false,
        pagination: 10,
        sort_default: [
          ["priority", "desc"],
          ["name", "asc"],
        ],
        sort: { priority: "desc", name: "asc", modified: "desc", id: "desc" },
        actions: [],
        columns: ["id", "title", "modified", "priority"],
      },
      image: {
        viewmode: "block",
        parent: 461,
        sort_default: [["modified", "desc"], "-"],
        block_fields: ["image", "name"],
      },
      school_image: {
        viewmode: "block",
        parent: 461,
        sort_default: [["modified", "desc"], "-"],
        block_fields: ["image", "name"],
      },
      user: {
        sort_default: [["modified", "desc"], "-"],
        parent: 4,
      },
    },
  };
};

export const getViewSettings = (contenttype: string) => {
  if (contenttype === "image") {
    return {
      inline_fields: ["image"],
      block_fields: ["name", "image"],
      browselist: {
        viewmode: "block",
        columns: ["name"],
        sort_default: [["published", "desc"]],
      },
    } as ViewSettingsType;
  } else {
    return {
      inline_fields: ["title"],
      browselist: {
        viewmode: "list",
        columns: ["name", "published"],
        sort_default: [["name", "desc"]],
        pagination: 2,
      },
    } as ViewSettingsType;
  }
};

// export const config = {
//   theme: "default",
//   default_url: "/main/467",
//   leftmenu: [
//     {
//       name: "ICD",
//       icon: "fa-desktop",
//       path: "/main/3",
//       menu: [
//         {
//           name: "ICD",
//           type: "leftmenu:treemenu",
//           contenttype: ["folder"],
//           icon: "fas fa-home",
//           open: true,
//           root: 3,
//         },
//       ],
//     },
//     {
//       name: "Users",
//       icon: "fa-users",
//       path: "/main/4",
//       menu: [
//         {
//           name: "Organizations",
//           type: "leftmenu:treemenu",
//           contenttype: ["usergroup"],
//           icon: "fas fa-sitemap",
//           root: 4,
//         },
//         {
//           name: "Roles",
//           type: "leftmenu:treemenu",
//           contenttype: ["role"],
//           icon: "fas fa-user-tag",
//           open: true,
//           root: 7,
//         },
//       ],
//     },
//   ],
//   main: {
//     "*": {
//       sort_default: [
//         ["priority", "desc"],
//         ["name", "asc"],
//       ],
//       sort: { id: "desc", priority: "desc", name: "asc" },
//       columns: ["id", "name", "priority"],
//       pagination: 25,
//       show_header: true,
//       show_table_header: true,
//       actions: [],
//       row_actions: [
//         { link: "/edit/{id}", name: "Edit", icon: "icon-edit" },
//         { com: "action:set_priority" },
//       ],
//     },
//     folder: {
//       list: [
//         "article:454",
//         "image:583",
//         "image:461",
//         "user:4",
//         "role:7",
//         "student:467",
//         "course:468",
//         "subject:469",
//         "agency:480",
//       ],
//       actions: [],
//       new: [
//         "article:465",
//         "folder:465",
//         "course:468",
//         "user:4",
//         "image:465",
//         "subject:469",
//         "agency:480",
//       ],
//     },
//     frontpage: {
//       list: ["frontpage_block"],
//       actions: [],
//       new: "",
//     },
//     usergroup: {
//       list: ["user"],
//       new: ["usergroup", "user"],
//       actions: [
//         {
//           link: "/edit/{id}",
//           title: "Edit this",
//           name: "Edit",
//         },
//       ],
//     },
//     role: {
//       view: true,
//       new: ["role"],
//       openSide: true,
//       list: [],
//     },
//     article: {
//       view: true,
//       actions: [
//         {
//           link: "/edit/{id}",
//           title: "Edit this",
//           name: "Edit",
//         },
//         {
//           com: "action:move",
//           icon: "icon icon-move",
//           name: "move",
//         },
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//     },
//     user: {
//       view: true,
//       metainfo: true,
//       view_com: "view:user",
//       actions: [
//         {
//           link: "/edit/{id}",
//           icon: "fa fa-edit",
//           title: "Edit this",
//           name: "Edit",
//         },
//       ],
//     },
//   },
//   comment: "---------Support default setting for list and others-------------",
//   list: {
//     _browse: {
//       article: {
//         sort: { name: "desc" },
//         columns: ["name"],
//         pagination: 20,
//         can_select: false,
//       },
//     },
//     folder: {
//       sort_default: [["published", "desc"]],
//       sort: [],
//       columns: ["name", "author", "published", "modified"],
//       show_header: true,
//       show_table_header: false,
//       actions: [],
//       row_actions: [],
//       pagination: 10,
//       row_more: ["export"],
//     },
//     student: {
//       sort_default: [["cid", "desc"]],
//       sort: {
//         student_no: "asc",
//         firstname: "asc",
//         lastname: "asc",
//         stage: "asc",
//         course: "asc",
//         intake: "asc",
//       },
//       columns: [
//         "student_no",
//         "firstname",
//         "lastname",
//         "course",
//         "stage",
//         "intake",
//         "agency",
//         "status",
//       ],
//       show_header: true,
//       can_select: true,
//       show_table_header: true,
//       actions: [{ com: "filter:student" }, { com: "action:delete-selected" }],
//       row_actions_visible: 10,
//       row_actions: [
//         {
//           link: "/student/view/{id}",
//           icon: "fas fa-angle-right",
//           name: "View",
//         },
//         {
//           link: "/finance/records/{id}",
//           icon: "fas fa-file-invoice-dollar",
//           name: "Fee",
//         },
//         {
//           link: "/subject/result/view/{id}",
//           icon: "fas fa-file",
//           name: "Subject records",
//         },
//         {
//           link: "/student/edit/{id}",
//           icon: "fas fa-edit",
//           name: "Edit",
//         },
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//       pagination: 15,
//       row_more: [],
//     },
//     course: {
//       sort_default: [["c.name", "asc"]],
//       sort: ["name"],
//       columns: ["id", "name", "is_bachelor"],
//       show_header: false,
//       show_table_header: true,
//       can_select: false,
//       actions: [],
//       row_actions: [
//         {
//           link: "/edit/course/{id}?from=/main/468",
//           icon: "fas fa-edit",
//           name: "Edit",
//         },
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//       pagination: 10,
//       row_more: [],
//     },
//     agency: {
//       sort_default: [["c.name", "asc"]],
//       sort: ["name"],
//       columns: ["id", "name"],
//       show_header: false,
//       show_table_header: true,
//       can_select: false,
//       actions: [],
//       row_actions: [
//         {
//           link: "/edit/agency/{id}?from=/main/480",
//           icon: "fas fa-edit",
//           name: "Edit",
//         },
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//       pagination: 10,
//       row_more: [],
//     },
//     subject: {
//       sort_default: [["c.name", "asc"]],
//       sort: { "c.name": "asc", course: "asc", stage_year: "asc" },
//       columns: ["name", "code", "course", "stage_year", "credit"],
//       show_header: false,
//       show_table_header: true,
//       can_select: false,
//       actions: [{ com: "filter:name" }],
//       row_actions: [
//         {
//           link: "/subject/view/{id}",
//           icon: "fas fa-angle-right",
//           name: "View",
//         },
//         {
//           link: "/edit/subject/{id}?from=/main/469",
//           icon: "fas fa-edit",
//           name: "Edit",
//         },
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//       pagination: 15,
//       row_more: [],
//     },
//     article: {
//       sort_default: [
//         ["priority", "desc"],
//         ["modified", "desc"],
//       ],
//       sort: {
//         name: "asc",
//         modified: "desc",
//         priority: "desc",
//         author_name: "asc",
//       },
//       columns: ["name", "coverimage", "author_name", "modified", "priority"],
//       show_header: true,
//       show_table_header: true,
//       actions: [],
//       row_actions: [
//         {
//           link: "/edit/{id}",
//           icon: "fas fa-edit",
//           name: "Edit",
//         },
//         {
//           link: "#",
//           icon: "fas fa-trash",
//           name: "Delete",
//         },
//       ],
//       pagination: 20,
//       row_more: ["export"],
//     },
//     frontpage: {
//       sort_default: [["published", "desc"]],
//       sort: [],
//       columns: ["name", "author", "published", "modified"],
//       show_header: true,
//       show_table_header: false,
//       actions: [],
//       row_actions: [],
//       pagination: 10,
//       row_more: ["export"],
//     },
//     image: {
//       sort_default: [["published", "desc"]],
//       sort: [],
//       columns: ["name", "image", "author", "published", "modified"],
//       block_fields: ["image", "name", "modified"],
//       show_header: true,
//       show_table_header: true,
//       actions: [],
//       viewmode: "block",
//       row_actions: [
//         {
//           link: "/edit/{_contenttype_id}?from=/main/{_from_id}",
//           name: "Edit",
//           icon: "icon-edit",
//         },
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//       pagination: 10,
//       row_more: ["export"],
//       blockview_columns: ["image", "name", "modified"],
//     },
//     usergroup: {
//       sort_default: [["published", "desc"]],
//       sort: [],
//       columns: ["name", "author", "published", "modified", "priority"],
//       show_header: true,
//       show_table_header: false,
//       actions: [],
//       row_actions: [],
//       pagination: 10,
//       row_more: [],
//     },
//     user: {
//       sort_default: [["name", "asc"]],
//       sort: { name: "asc", modified: "desc" },
//       columns: ["cid", "name", "published", "modified"],
//       show_header: true,
//       show_table_header: true,
//       can_select: false,
//       actions: [],
//       row_actions: [
//         {
//           link: "/edit/{_contenttype_id}?from=/main/{_from_id}",
//           name: "Edit",
//           icon: "icon-edit",
//         },
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//       pagination: 25,
//       row_more: [],
//     },
//     role: {
//       sort_default: [["name", "asc"]],
//       sort: { name: "asc", modified: "desc" },
//       columns: ["id", "name", "published", "modified"],
//       show_header: true,
//       show_table_header: true,
//       can_select: false,
//       actions: [],
//       row_actions: [
//         {
//           com: "action:delete",
//           icon: "fas fa-trash",
//           name: "delete",
//         },
//       ],
//       pagination: 25,
//       row_more: [],
//     },
//   },
//   browse: {
//     filter: {
//       "*": { contenttype: ["folder"] },
//       usergroup: { contenttype: ["usergroup"] },
//       user: { contenttype: ["folder"] },
//       sv_product: { contenttype: ["sv_product_package"] },
//     },
//     list: {
//       "*": {
//         level: 1,
//         can_select: false,
//         pagination: 10,
//         sort_default: [
//           ["priority", "desc"],
//           ["name", "asc"],
//         ],
//         sort: { priority: "desc", name: "asc", modified: "desc", id: "desc" },
//         actions: [],
//         columns: ["id", "title", "modified", "priority"],
//       },
//       image: {
//         viewmode: "block",
//         parent: 461,
//         sort_default: [["modified", "desc"], "-"],
//         block_fields: ["image", "name"],
//       },
//       user: {
//         sort_default: [["modified", "desc"], "-"],
//         parent: 4,
//       },
//       role: {
//         sort_default: [["name", "asc"], "-"],
//         parent: 7,
//       },
//     },
//   },
//   viewmode: {
//     inline: {
//       article: ["name"],
//       image: ["image"],
//       user: ["name"],
//       role: ["name"],
//     },
//     block: {
//       article: ["title"],
//       image: ["image", "name"],
//     },
//   },
// };
